import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../assets/LinkedIn-Local-Cameroon-Logo.png';
import logoWhite from '../assets/LinkedIn-Local-Cameroon-Logo-white.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
      setShowTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setMenuOpen(false);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/speakers', label: 'Speakers' },
    { to: '/tickets', label: 'Buy Ticket' },
    { to: '/sponsors', label: 'Become a Sponsor' },
    { to: '/awards', label: 'Apply for Award' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/faq', label: 'FAQ' },
    { to: '/contact', label: 'Contact Us' },
  ];

  const socials = [
    { href: 'https://www.linkedin.com/company/linkedin-local-cameroon/', icon: 'in', label: 'LinkedIn' },
    { href: 'https://www.facebook.com/profile.php?id=61587542943056', icon: 'f', label: 'Facebook' },
    { href: 'https://www.instagram.com/linkedinlocalcameroon?igsh=bm9oZDY4ZHM0cTM2', icon: 'ig', label: 'Instagram' },
  ];

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar__inner">
            <div className="top-bar__left">
              <div className="top-bar__contact-item">
                <svg width="13" height="13" fill="white" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <a href="mailto:info@linkedinlocalcameroon.com">info@linkedinlocalcameroon.com</a>
              </div>
              <div className="top-bar__contact-item">
                <svg width="13" height="13" fill="white" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:+237000000000">+237 683 66 85 18</a>
              </div>
            </div>
            <div className="top-bar__right">
              {socials.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  className="top-bar__social" aria-label={s.label}
                  style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 10, fontWeight: 800 }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* MAIN NAVBAR */}
      <nav className="navbar">
        <div className="container">
          <div className="navbar__inner">
            <NavLink to="/" className="navbar__logo" onClick={close} aria-label="Home">
              <img src={logo} alt="LinkedIn Local Cameroon Logo" />
            </NavLink>

            {/* Desktop links */}
            <ul className="navbar__links">
              {navLinks.slice(0, -1).map(link => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    end={link.to === '/'}
                    className={({ isActive }) => isActive ? 'active' : ''}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <NavLink to="/contact" className="navbar__links" style={{ display: 'none' }} />
              <NavLink to="/tickets" className="navbar__cta">Get Ticket</NavLink>
              <button
                className={`navbar__hamburger${menuOpen ? ' open' : ''}`}
                onClick={() => setMenuOpen(m => !m)}
                aria-label="Toggle menu"
              >
                <span /><span /><span />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`navbar__mobile${menuOpen ? ' open' : ''}`}>
          {navLinks.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={close}
            >
              {link.label}
            </NavLink>
          ))}
          <NavLink to="/tickets" className="mobile-cta" onClick={close} style={{ textDecoration: 'none', textAlign: 'center', display: 'block', padding: '12px', borderRadius: '50px', background: 'var(--red)', color: '#fff', fontFamily: 'Montserrat,sans-serif', fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: 'uppercase', marginTop: 8 }}>
            Get Ticket
          </NavLink>
        </div>
      </nav>

      {/* SCROLL TO TOP */}
      <button
        className={`scroll-top${showTop ? ' visible' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </>
  );
};

export default Navbar;
